import clsx from 'clsx';
import type { ReactNode } from 'react';

type SurveyPanelProps = {
  children: ReactNode;
  className?: string;
};

export function SurveyContentPanel({ children, className }: SurveyPanelProps) {
  return (
    <div
      className={clsx(
        'w-full rounded-md bg-white/25 px-3 py-3 text-center text-[18px] font-bold leading-snug text-white text-pretty text-balance shadow-sm sm:px-4 sm:text-[20px]',
        className
      )}
    >
      {children}
    </div>
  );
}

/** Grey rounded panel for survey questions with inputs (matches thank-you corner radius). */
export function SurveyFormPanel({ children, className }: SurveyPanelProps) {
  return (
    <div
      className={clsx(
        'w-full rounded-md bg-neutral-300/95 px-4 py-4 text-left shadow-sm sm:px-5',
        className
      )}
    >
      {children}
    </div>
  );
}

/** Frosted panel for standalone question headings. */
export function SurveyQuestionPanel({ children, className }: SurveyPanelProps) {
  return (
    <SurveyContentPanel className={clsx('!py-3 !text-left', className)}>{children}</SurveyContentPanel>
  );
}

export const surveyQuestionTextClass =
  'm-0 break-words text-left text-[16px] font-semibold leading-snug text-black sm:text-[17px]';

export const surveyQuestionTextOnPanelClass =
  'm-0 break-words text-left text-[16px] font-bold leading-snug text-white sm:text-[17px]';

/** Full-width panel within layout padding; symmetric horizontal inset avoids clipped text. */
export function SurveyContentPanelInset({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={clsx('min-w-0 w-full', className)}>{children}</div>;
}
